import { useRef, useEffect } from 'react'

/** 组件初始化时调用 */
export function useCreate(callBack: () => any) {

  // 记录是否已经初始化过了
  const initRef = useRef(false)
  // 卸载时触发的函数
  const unmount = useRef<(...args: any) => any>(null!)

  // 执行卸载操作
  useEffect(() => () => unmount.current?.(), [])

  if (!initRef.current) {
    queueMicrotask(async () => {
      //  取得返回值
      let result: any = callBack()
      if (result instanceof Promise) {
        result = await result
      }
      if (typeof result === 'function') {
        unmount.current = result
      }
    })
    initRef.current = true
  }

}